import { render, staticRenderFns } from "./serviceAlert.vue?vue&type=template&id=3b441428&scoped=true"
import script from "./serviceAlert.vue?vue&type=script&lang=js"
export * from "./serviceAlert.vue?vue&type=script&lang=js"
import style0 from "./serviceAlert.vue?vue&type=style&index=0&id=3b441428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b441428",
  null
  
)

export default component.exports